/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
// import { ASSETS_TABLE } from "../pages/ListedAssetsTable/graphql/listed-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
    PRODUCT_IMG,
    ORGANIZATION_INFO,
    PRODUCT_DETAIL_INFO,
    PRODUCT_TITLE_CARD,
} from "./config/product-detail-view";
import { GET_PRODUCT_DETAIL } from "../pages/ProductDetailView/graphql/get-product-detail.query";

const SERVICE_NAME = "product-detail-view.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ProductDetailViewService {
    name = SERVICE_NAME;
    private static instance: ProductDetailViewService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ProductDetailViewService();
        }
        return this.instance;
    }

    _getImages(images: any) {
        let resultImg: any[] = [];
        images &&
            Array.isArray(images) &&
            images.forEach((item: any, index: number) => {
                if (item?.image)
                    resultImg.push({
                        original: item?.image,
                        thumbnail: item?.image,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                    });
            });
        return resultImg;
    }

    async productDetailView(payload: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PRODUCT_DETAIL,
                    variables: {
                        gtinKey: payload,
                    },
                    fetchPolicy: "network-only",
                });
                log.blue(
                    `product detaul in service:`,
                    res?.data?.getDecodedProduct
                );
                let _data = res?.data?.getDecodedProduct?.data?.productDetails;
                if (_data)
                    return {
                        PRODUCT_IMG: this._getImages(
                            _data?.ProductImages?.productImages
                        ),
                        ORGANIZATION_INFO: _data?.OrganizationInfo,
                        PRODUCT_DETAIL_INFO: _data?.ProductDetailInfo,
                        PRODUCT_TITLE_CARD: _data?.ProductTitleCard
                    };
            }
            // let _data = {
            //     PRODUCT_IMG,
            //     ORGANIZATION_INFO,
            //     PRODUCT_DETAIL_INFO,
            //     PRODUCT_TITLE_CARD,
            // };
            // return _data;
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}